module.exports = {
    system: {
        userManage: 'ユーザー管理',
        productManage: '商品管理',
        labelField: '棚札フィールド',
        versionManage: 'ハードウェアバージョン',
        updateStatus: '最新状況',
        system: 'システム',
        operate: '運営',
        add: '追加',
        edit: '修正',
        del: '削除する',
        sure: '確定',
        cancel: 'キャンセル',
        details: '詳細を更新',
        submiting: '提出中...',
        productTab: {
            search: '検索する',
            download: 'ダウンロード',
            import: 'インポート',
            importTip: {
                success: 'インポート成功、{success}成功',
                fail: 'インポートに失敗しました',
                excel: 'インポートされたファイルのサフィックス名は、xlsxまたはxlsのみです。',
                format: 'ファイル形式が正しくありません',
                parseFail: 'ファイルの解析に失敗しました',
                permission: '商品をインポートする権限がありません',
                chooseFile: 'ファイルの選択',
                uploadFile: 'アップロード：',
                chooseStore: '店舗の選択：',
                findStore: 'お店を探す',
                notEmpty: 'アップロードファイルを空にすることはできません',
                notStore: 'お店をお選びください',
                getStoreInfoFail: 'ストア情報のクエリに失敗しました',
                getUpdateInfoFail: '更新ステータスのクエリに失敗しました',
                getUpdateInfoDetailFail: 'クエリの更新の詳細に失敗しました',
                processing:'最後の製品インポート処理が完了するまでお待ちください'
            },
            addTip: {
                success: '商品が正常に追加されました',
                exist: 'アイテムはすでに存在します',
                fail: '商品を追加できませんでした',
                msg: '{productName}を削除してもよろしいですか？',
                permission: '商品を作成する権限がありません'
            },
            editTip: {
                success: '商品は正常に変更されました',
                exist: '変更された製品は存在しません',
                fail: '商品の変更に失敗しました',
                permission: '商品を変更する権限がありません'
            },
            delTip: {
                success: '商品が正常に削除されました',
                exist: '削除されたアイテムは存在しません',
                fail: '商品を削除できませんでした',
                msg: 'ID {id}の商品を削除してもよろしいですか？',
                delSelect: '選択した商品を削除してもよろしいですか？',
                delSelectFirst: 'まず削除したい商品を選択してください！',
                permission: '商品を削除する権限がありません'
            },
            productAttr: {
                num: '番号',
                productNo: '商品番号',
                productName: '商品名',
                proAbbr: '商品の略称',
                price: '価格',
                brand: 'ブランド',
                origin: '産地',
                specification: '規格',
                rating: 'ランク',
                piece: '単位',
                qrcode: 'QRコード',
                barcode: 'バーコード',
                supplierName: 'ベンダー名'
            },
            tips: {
                title: 'ヒント',
                addTip: '追加した商品データは、同時に各店舗に追加されます',
                editTip: 'この操作により、各店舗の同じ商品データが同時に変更されます',
                delTip: 'この操作により、各店舗の同じ商品データが同時に削除されます',
                importTip: 'インポートされた商品データは、各店舗に同時に追加されます',
                downTip: 'ここからダウンロードしたテンプレートファイル形式を使用してデータをインポートする'
            }
        },
        userTab: {
            edit: '修正',
            del: '削除する',
            addTip: {
                success: 'ユーザーが正常に追加されました',
                exist: 'ユーザーはすでに存在します',
                fail: 'ユーザーが追加できませんでした',
                msg: '{userName}を削除してもよろしいですか？',
                permission: 'ユーザーを作成する権限がありません'
            },
            editTip: {
                success: 'ユーザーが正常に変更されました',
                exist: '変更されたユーザーは存在しません',
                fail: 'ユーザーの変更に失敗しました',
                permission: 'ユーザーを変更する権限がありません'
            },
            delTip: {
                success: 'ユーザーが正常に削除されました',
                exist: '削除されたユーザーは存在しません',
                fail: 'ユーザーを削除できませんでした',
                msg: '{userName}を削除してもよろしいですか？',
                permission: 'ユーザーを削除する権限がありません'
            },
            userAttr: {
                userNo: 'ユーザーID',
                userName: 'ユーザー名',
                nickName: 'お名前',
                password: 'ユーザーパスワード',
                isValid: '有効ですか',
                validOpt: [{
                    label: 'はい',
                    value: true
                }, {
                    label: 'いいえ',
                    value: false
                }],
                // istype: '値札タイプ',
                // type: [{
                //     label: 'ゲートウェイ版',
                //     value: 0
                // }, {
                //     label: 'モバイル版',
                //     value: 1
                // }]
            }
        },
        labelTab: {
            labelTitle: '棚札プレフィックスの編集',
            field: 'フィールドID',
            idName: '商品名',
            eslPrefix: '棚札プレフィックス',
            proNo: '商品番号:',
            name: '商品名:',
            proAbbr: '商品略称:',
            price: '価格:',
            brand: 'ブランド:',
            specification: '規格:',
            rating: 'ランク:',
            piece: '単位:',
            origin: '産地:',
            supplierName: 'ベンダー:',
            switch: '中国語/英語',
            save: '保存',
            labelTip: {
                save: '保存',
                msg: '棚札フィールドのプレフィックスを変更してもよろしいですか？',
                success: '棚札フィールドプレフィックスが正常に変更されました',
                fail: '棚札フィールドのプレフィックスを変更できませんでした'
            },
            title: 'ヒント',
            tip: 'この関番号は、棚札プレフィックスの編集を実装します。変更して保存した後、対応する電子棚札を有効にするために棚札を更新する必要があります。'
        },
        versionTab: {
            label: '棚札',
            gateway: 'ゲートウェイ',
            uploadESL: 'アップロードする',
            uploadGwWifi: 'WiFiハードウェアをアップロードする',
            uploadGwBle: 'BLEハードウェアをアップロードする',
            tips: {
                title: 'ヒント',
                uploadESLTip: 'アップロードされた棚札ハードウェアは、すべてのストア棚札のハードウェアをアップグレードします',
                uploadGwWifiTip: 'アップロードされたWiFiハードウェアは、すべてのストアゲートウェイのWiFiハードウェアをアップグレードします',
                uploadGwBleTip: 'アップロードされたBleハードウェアは、すべてのストアゲートウェイのBleハードウェアをアップグレードします'
            },
            gwUpgradeLogs: {
                num: '番号',
                codeName: 'プログラム名',
                uploadTime: 'アップロード時間',
                versionNum: 'バージョン番号',
                type: 'タイプ'
            },
            gwWifiUpgradeTips: {
                format: 'アップロードされたハードウェアは、正しい形式のbinファイルでなければなりません',
                loading: 'ゲートウェイWiFiハードウェアのアップロード...',
                success: 'ゲートウェイWiFiハードウェアが正常にアップロードされました',
                fail: 'ゲートウェイWiFiハードウェアのアップロードに失敗しました'
            },
            gwBleUpgradeTips: {
                format: 'アップロードされたハードウェアは正しい形式のzipファイルでなければなりません',
                loading: 'ゲートウェイBluetoothハードウェアのアップロード...',
                success: 'ゲートウェイBluetoothハードウェアが正常にアップロードされました',
                fail: 'ゲートウェイBluetoothハードウェアのアップロードに失敗しました'
            },
            gwDelTips: {
                msg: '{packageName}を削除してもよろしいですか？',
                success: '正常に削除されました',
                fail: '削除できませんでした',
            },
            table1: {
                index: '番号',
                name: 'プログラム名',
                uploadTime: 'アップロード時間',
                version: 'バージョン番号',
                type: 'タイプ',
                format: 'アップロードされたハードウェアは、正しい形式のbinファイルでなければなりません',
                loading: '棚札ハードウェアのアップロード...',
                success: '棚札のハードウェアを正常にアップロードしました',
                fail: '棚札ハードウェアのアップロードに失敗しました',
                queryFailInfo: '棚札ハードウェアバージョン情報の検索に失敗しました',
                del: '削除する',
                msg: '{version}バージョン棚札のハードウェアアップグレードパッケージを削除してもよろしいですか？',
                upgradeSuccess: '棚札ハードウェアアップグレードパッケージが正常に削除されました',
                upgradeFail: '棚札ハードウェアアップグレードパッケージを削除できませんでした'
            }
        },
        updateTab: {
            rePush: 'ワンクリックで再プッシュ',
            num: '番号',
            fileName: 'ファイル名',
            importTime: 'インポート時間',
            tip: {
                title: '詳細を更新',
                tip: 'ヒント',
                getUpdateStatusFail: '更新ステータスのクエリに失敗しました',
                getUpdateStatusDetailFail: 'クエリの更新の詳細に失敗しました',
                rePushTip: 'ワンクリックで再プッシュすると、新しくインポートされたデータで更新に失敗したストアが再プッシュされます',
                msg: '更新に失敗したストアを再プッシュしてもよろしいですか?',
                rePushSuccess: 'ワンクリックの再プッシュ命令が正常に送信されました。後でページを更新して最新のデータを取得してください。',
                rePushFail: 'ワンキープッシュコマンドの送信に失敗しました',
                wait: '最後のシステムインポートまたはワンクリックの再プッシュ処理が完了するまでお待ちください'
            },
            table: {
                storeId: 'ストアID',
                storeName: '店舗名',
                currentStatus: '現在の状態',
                successNumber: '成功数',
                failedNumber: '失敗の数',
                total: '合計'
            },
            format: {
                status: [{
                    key: 0,
                    value: 'アップグレード待ち'
                },{
                    key: 1,
                    value: '更新'
                },{
                    key: 2,
                    value: '更新しました'
                },{
                    key: 3,
                    value: 'ゲートウェイ異常'
                }]
            }
        },
        prefix: { //获取标签前缀
            fail: '棚札プレフィックスを取得できませんでした'
        },
        validMsg: {
            user: {
                userName: 'ユーザー名を入力してください',
                nameValid: '文字または番号字を入力してください',
                nameExist: 'ユーザーはすでに存在します',
                nameFail: '失敗しました。再入力してください',
                // nameLen:'長さは20文字を超えることはできません',
                nickName: '名前を入力してください',
                isValid: 'オプションを選択してください',
                password: 'ユーザーパスワードを入力してください',
                length1: '6-20桁のパスワードを入力してください',
                passRule: 'パスワードにスペースを含めることはできません',
                passRule1: 'パスワードに中国語を含めることはできません'
            },
            pro: {
                productName: '商品名を入力してください',
                nameLen: '長さは20文字以下',
                // priceRule:'小数点以下は2桁まで',
                priceRule1: '正しい形式を入力してください',
                priceRule2: '小番号点以下2桁まで入力してください',
                barcode: 'IDを入力してください',
                // barcodeValid:'有効なean13バーコードを入力してください',
                barcodeValid: '13桁を入力してください',
                barcodeExist: 'アイテムが追加されました',
                barcodeFail: '失敗しました。再入力してください',
                proNoRule: '文字または番号字を入力してください'
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/common/lang/ja/system.js